<template>
     <section class="refiners">
        <!-- Mobile only overview modal -->
      <button class="filter-button" @click="toggleOverviewModal">
        <span class="filter-icon"></span>
      </button>
      <Modal
      v-if="isOverviewModalOpen"
      class="overview-modal"
      :is-open="isOverviewModalOpen"
      :title="labels.filters"
      :hideSearch="true"
      :count="selectedFacetOptions.length"
      :labels="labels"
      @close="toggleOverviewModal"
      @reset="onResetFilters(true)"
      >
        <div class="facet-selectors">
          <div v-for="(facet, index) in results.facets" :key="facet.name" class="facet-selector-wrapper">
            <FacetSelector
              v-if="hiddenFacets.indexOf(facet.name) === -1" 
              :key="facet.name"
              :label="facet.name"
              @click="toggleModal(facet.name, true)"
              :count="selectedFacetOptions.filter(option => option.startsWith(facet.id)).length"
            />
          </div>
          <!-- Slot for mobile custom filters -->
          <div class="custom-filters-mobile">
            <slot name="custom-filters"></slot>
          </div>
        </div>
      </Modal>
      <!-- Pill filters -->
      <div v-for="(facet, index) in results.facets" :key="facet.name" class="pill-wrapper">
        <Pill v-if="hiddenFacets.indexOf(facet.name) === -1"
            :key="`${facet.name}`"
            :label="facet.name"
            :options="facet.options" 
            :isModalOpen="openModalKey === facet.name"
            :facetId="facet.id"
            :showBackButton="showFilterModalBackButton"
            :selectedOptions="selectedFacetOptions"
            :initiallySelectedOptions="selectedFacetOptions.filter(option => option.startsWith(facet.id))"
            :labels="labels"
            @apply="(selectedOptions) => onApplyFilters(facet.id, selectedOptions)" 
            @toggle="toggleModal(facet.name)" 
            @reset="onResetFilters(false, facet.id)"
        />
      </div>
      <!-- Slot for desktop custom filters -->
      <div class="custom-filters">
        <slot name="custom-filters"></slot>
      </div>
    </section>
</template>

<script>
import { Labels } from '../services/labels.js'
import { Settings } from '../services/settings.js'
import Facet from './Facet.vue'
import FacetOption from './FacetOption.vue'
import Pill from './Pill.vue'
import Modal from './Modal.vue'
import FacetSelector from './FacetSelector.vue'

export default {
  name: 'SearchRefiners',
  components: {
    Facet,
    FacetOption,
    Pill,
    Modal,
    FacetSelector
  },
  props: {
    results: {
      type: Object,
      required: true
    },
    selectedFacetOptions: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      labels: Labels,
      settings: Settings,
      hiddenFacets: Settings.hiddenFacets,
      removeCountryFilter: false,
      openModalKey: null,
      isOverviewModalOpen: false,
      showFilterModalBackButton: false,
    }
  },
  methods: {
    toggleOverviewModal() {
      this.isOverviewModalOpen = !this.isOverviewModalOpen;
      this.openModalKey = null;
    },
    onApplyFilters(facetId, selectedOptions) {
      this.$emit('applyFilters', facetId, selectedOptions);
      this.isOverviewModalOpen = false;
    },
    toggleModal(facetName, fromOverview) {
      this.openModalKey = this.openModalKey === facetName ? null : facetName;
      this.showFilterModalBackButton = fromOverview;
    },
    onResetFilters(all, facetId) {
      this.$emit('resetFilters', all, facetId);
      this.isOverviewModalOpen = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.refiners {
  margin-bottom: 32px;
  display: inline-flex;
}

.refiners .pill-wrapper {
  display: inline-flex;
}

.refiners .country-products {
  margin-top: 0px;
  margin-left: 16px;
}

.filter-button {
  display: none; /* Hidden by default on desktop */
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  border: 1px solid #2655ff;
  border-radius: 4px;
  background: white;
  flex-shrink: 0;
  cursor: pointer;
  padding: 2px;
  margin-right: 4px;
}

.filter-icon {
  width: 16px;
  height: 16px;
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.11385 11.5002C3.3884 10.7234 4.12923 10.1668 5.00004 10.1668C5.87084 10.1668 6.61171 10.7234 6.88624 11.5002H13.6667V12.8335H6.88624C6.61171 13.6103 5.87084 14.1668 5.00004 14.1668C4.12923 14.1668 3.3884 13.6103 3.11385 12.8335H0.333374V11.5002H3.11385ZM7.11384 6.8335C7.38837 6.0567 8.12924 5.50016 9.00004 5.50016C9.87084 5.50016 10.6117 6.0567 10.8862 6.8335H13.6667V8.16683H10.8862C10.6117 8.94363 9.87084 9.50016 9.00004 9.50016C8.12924 9.50016 7.38837 8.94363 7.11384 8.16683H0.333374V6.8335H7.11384ZM3.11385 2.16683C3.3884 1.39004 4.12923 0.833496 5.00004 0.833496C5.87084 0.833496 6.61171 1.39004 6.88624 2.16683H13.6667V3.50016H6.88624C6.61171 4.27696 5.87084 4.8335 5.00004 4.8335C4.12923 4.8335 3.3884 4.27696 3.11385 3.50016H0.333374V2.16683H3.11385ZM5.00004 3.50016C5.36823 3.50016 5.66671 3.20168 5.66671 2.8335C5.66671 2.46531 5.36823 2.16683 5.00004 2.16683C4.63185 2.16683 4.33337 2.46531 4.33337 2.8335C4.33337 3.20168 4.63185 3.50016 5.00004 3.50016ZM9.00004 8.16683C9.36824 8.16683 9.66671 7.86836 9.66671 7.50016C9.66671 7.13196 9.36824 6.8335 9.00004 6.8335C8.63184 6.8335 8.33337 7.13196 8.33337 7.50016C8.33337 7.86836 8.63184 8.16683 9.00004 8.16683ZM5.00004 12.8335C5.36823 12.8335 5.66671 12.535 5.66671 12.1668C5.66671 11.7986 5.36823 11.5002 5.00004 11.5002C4.63185 11.5002 4.33337 11.7986 4.33337 12.1668C4.33337 12.535 4.63185 12.8335 5.00004 12.8335Z' fill='%232655FF'/%3E%3C/svg%3E%0A");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.facet-selectors {
  display: flex;
  flex-direction: column;
}

.overview-modal {
  display: none;
}

.custom-filters {
  margin-left: 16px;
}

.custom-filters-mobile {
  margin-top: 32px;
}

@media all and (max-width: 780px) {
  .refiners {
    display: flex;
    overflow-x: auto;
    flex-wrap: nowrap;
    white-space: nowrap;
    padding: 10px 0px;
    gap: 4px
  }

  .refiners .country-products {
    display: none;
  }

  .refiners .country-products-mobile {
    display: block;
    margin-top: 32px;
  }

  .filter-button {
    display: flex;
  }

  .overview-modal {
    display: block;
  }

  .custom-filters {
    display: none;
  }

  .custom-filters-mobile {
    display: block;
  }
}
</style>